<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @if (roleService.can('read', 'client') | async)  {
    <a
      mat-tab-link
      routerLink="clients"
      routerLinkActive
      #rla1="routerLinkActive"
      [active]="rla1.isActive">Lista de Clientes</a>
  }
  <a
    mat-tab-link
    routerLink="bookings"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive">{{ 'crm/booking' | human }}</a>
  <a
    mat-tab-link
    routerLink="bookings"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive">{{ 'crm/absence' | human }}</a>
  <a
    mat-tab-link
    routerLink="bookings"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive">{{ 'crm/marketing' | human }}</a>
</nav>
<mat-tab-nav-panel #tabPanel style="padding: 0;">
  <router-outlet></router-outlet>
</mat-tab-nav-panel>

